import * as angular from "angular";
import { DialogUtils } from "../../helper/dialog.helper";

let RecommendedStepsComponent = {
    selector: "vcRecommendedSteps",
    templateUrl:
        "/angular/components/campaign/recommended-steps.component.html",
    bindings: {
        page: "=",
    },
    controller: class RecommendedStepsComponentController {
        // * bindings for typescript compiler *
        public page: number;
        // ************************************
        public step: number = 1;

        public setupSteps = [
            [
                {
                    title: "Import Data",
                    subtext:
                        "We've pre-populated your dashboard with sample data which you can use until you're ready.",
                    actionButton: "Import",
                    link: "/#/voterfiles",
                    icon: "upload",
                },
                {
                    title: "Invite your team",
                    subtext:
                        "Add internal or external team members and give access to those who need it.",
                    actionButton: "Invite User",
                    icon: "person_add",
                    function: () => {
                        this.openInviteDialog();
                    },
                },
                {
                    title: "Install Ecanvasser App",
                    subtext:
                        "Download the app and start using your canvassing tools on the go and offline.",
                    actionButton: "Install App",
                    icon: "install_mobile",
                    function: () => {
                        this.openAppsDialog();
                    },
                },
            ],
            [
                {
                    title: "Open Users & Teams",
                    subtext: "Access the dashboard to manage users.",
                    actionButton: "View",
                    link: "/#/users",
                    icon: "edit",
                },
                {
                    title: "Send Invitations",
                    subtext: "Enter emails and assign roles",
                    actionButton: "Invite",
                    icon: "upload",
                    function: () => {
                        this.openInviteDialog();
                    },
                },
                {
                    title: "Configure Permissions",
                    subtext:
                        "Adjust user roles based on their responsibilities.",
                    actionButton: "Set",
                    link: "/#/customize?tab=features",
                    icon: "person_add",
                },
            ],
            [
                {
                    title: "Prepare CSV File",
                    subtext: "Ensure data is formatted correctly.",
                    actionButton: "Prepare File",
                    link: "https://support.ecanvasser.com/en/articles/1001109-importing-a-contact-file-into-ecanvasser#h_91a4168113",
                    icon: "edit",
                },
                {
                    title: "Upload to Ecanvasser",
                    subtext: "Use the import tool to add your contacts.",
                    actionButton: "Upload File",
                    link: "/#/voterfiles",
                    icon: "upload",
                },
                {
                    title: "Map Data Fields",
                    subtext: "Match CSV columns with Ecanvasser fields.",
                    actionButton: "Map Fields",
                    link: "https://support.ecanvasser.com/en/articles/1001109-importing-a-contact-file-into-ecanvasser#h_1369e31273",
                    icon: "swap_horiz",
                },
            ],
            [
                {
                    title: "Explore Web App",
                    subtext: "Navigate through key features and menus.",
                    actionButton: "Explore",
                    link: "https://support.ecanvasser.com/en/articles/1000121-your-quick-start-guide-to-ecanvasser",
                    icon: "explore",
                },
                {
                    title: "Customize App",
                    subtext: "Adjust your settings and permissions.",
                    actionButton: "Customize",
                    link: "/#/customize",
                    icon: "tune",
                },
                {
                    title: "Download Mobile App",
                    subtext: "Install Ecanvasser on your device.",
                    actionButton: "Download",
                    function: () => {
                        this.openAppsDialog();
                    },
                    icon: "download",
                },
            ],
            [
                {
                    title: "Open Map View",
                    subtext: "Access maps for visual territory planning.",
                    actionButton: "Open Map",
                    link: "/#/map",
                    icon: "map",
                },
                {
                    title: "Cut Turf Areas",
                    subtext: "Define canvassing zones.",
                    actionButton: "Cut Turf",
                    link: "https://ecanvasser.wistia.com/medias/haojkw288p",
                    icon: "content_cut",
                },
                {
                    title: "Assign to Teams",
                    subtext: "Distribute turf areas to team members.",
                    link: "https://support.ecanvasser.com/en/articles/5898664-how-to-assign-lists-manage-territories",
                    actionButton: "Assign",
                    icon: "group_work",
                },
            ],
            [
                {
                    title: "Review Default Statuses",
                    subtext: "Check pre-set interaction statuses.",
                    actionButton: "Review",
                    link: "/#/customize?tab=statuses",
                    icon: "visibility",
                },
                {
                    title: "Customize Statuses",
                    subtext: "Add, edit, or remove statuses.",
                    actionButton: "Customize",
                    link: "https://support.ecanvasser.com/en/articles/2640816-interaction-statuses",
                    icon: "edit",
                },
                {
                    title: "Train Your Team",
                    subtext: "Ensure users understand how to log interactions.",
                    actionButton: "Train",
                    link: "https://support.ecanvasser.com/en/articles/5145764-walk-app-interactions",
                    icon: "school",
                },
            ],
            [
                {
                    title: "Enable GPS Tracking",
                    subtext: "Activate location services on devices.",
                    actionButton: "Enable",
                    link: "https://support.ecanvasser.com/en/articles/5099952-permission-settings#h_8ed6761523",
                    icon: "gps_fixed",
                },
                {
                    title: "Monitor Field Activities",
                    subtext: "Use the dashboard to view real-time movements.",
                    actionButton: "Monitor",
                    icon: "monitor_heart",
                    link: "/#/canvasser/activity",
                },
                {
                    title: "Review Activity Logs",
                    subtext: "Analyze field data for performance insights.",
                    actionButton: "Review",
                    icon: "analytics",
                    link: "https://support.ecanvasser.com/en/articles/4560852-field-tracking#viewing-your-canvasser-report",
                },
            ],
            [
                {
                    title: "Configure App Settings",
                    subtext:
                        "Customize canvassing workflows and user preferences.",
                    actionButton: "Configure",
                    link: "https://support.ecanvasser.com/en/articles/2721045-building-your-customized-canvassing-app",
                    icon: "settings",
                },
                {
                    title: "Enable Surveys & Scripts",
                    subtext: "Create structured interactions for field teams.",
                    actionButton: "Enable",
                    link: "/#/survey",
                    icon: "checklist",
                },
                {
                    title: "Test in Preview Mode",
                    subtext:
                        "Verify everything works as expected before rolling out to your field team.",
                    actionButton: "Test",
                    function: () => {
                        this.openVerifyDialog();
                    },
                    icon: "bug_report",
                },
            ],

            [
                {
                    title: "Define Territories",
                    subtext: "Set up geographic canvassing zones.",
                    actionButton: "Define",
                    icon: "draw",
                },
                {
                    title: "Assign Field Teams",
                    subtext: "Distribute territories to team members.",
                    actionButton: "Assign",
                    icon: "group_add",
                },
                {
                    title: "Monitor Coverage",
                    subtext: "Track canvassing progress in real-time.",
                    actionButton: "Monitor",

                    icon: "track_changes",
                },
            ],
            [
                {
                    title: "Enable Helpdesk",
                    subtext: "Activate helpdesk for ticket management.",
                    actionButton: "Enable",
                    icon: "help_center",
                },
                {
                    title: "Use Follow-Up",
                    subtext: "Send & track responses and set reminders.",
                    actionButton: "Set Up",
                    icon: "follow_the_signs",
                },
                {
                    title: "Monitor Trends",
                    subtext: "Review follow up history and engagement trends.",
                    actionButton: "Monitor",

                    icon: "trending_up",
                },
            ],
            [
                {
                    title: "Review Dashboards",
                    subtext: "Monitor campaign performance in real time.",
                    actionButton: "Review",
                    icon: "dashboard",
                },
                {
                    title: "Customize Reports",
                    subtext: "Track key performance indicators.",
                    actionButton: "Customize",

                    icon: "summarize",
                },
                {
                    title: "Analyze Trends",
                    subtext: "Adjust strategies based on collected data.",
                    actionButton: "Analyze",
                    icon: "insights",
                },
            ],
            [
                {
                    title: "Configure User Roles",
                    subtext: "Set appropriate access levels.",
                    actionButton: "Configure",

                    icon: "admin_panel_settings",
                },
                {
                    title: "Enable Security Features",
                    subtext: "Turn on Two-Factor Authentication.",
                    actionButton: "Enable",
                    icon: "security",
                },
                {
                    title: "Review Privacy Settings",
                    subtext:
                        "Ensure compliance with data protection standards.",
                    actionButton: "Review",
                    icon: "privacy_tip",
                },
            ],
        ];

        public steps: any;

        private $scope: any;
        private dialog: DialogUtils;

        constructor($scope: any, DialogUtils: DialogUtils) {
            this.$scope = $scope;
            this.dialog = DialogUtils;
        }

        $onInit() {
            let page = this.page ?? 1;
            this.setSteps(page);

            this.$scope.$watch(
                () => this.page,
                (newValue, oldValue) => {
                    if (!!newValue && newValue != oldValue) {
                        this.setSteps(newValue);
                    }
                },
                true
            );
        }

        setSteps(page: number): void {
            this.step = 1;
            this.steps = this.setupSteps[page - 1];
        }

        openVerifyDialog(): void {
            this.dialog.show({
                component: "vc-verify-dialog",
                skipHide: true,
                clickOutsideToClose: true,
                scope: this.$scope,
                ariaLabel: "Verify App",
                size: "med",
            });
        }
        openInviteDialog(): void {
            this.dialog.show({
                component: "vc-user-invite",
                clickOutsideToClose: false,
                size: "large-plus",
            });
        }
        openAppsDialog() {
            this.dialog.show({
                templateUrl:
                    "/angular/components/checklist/apps-dialog.component.html",
                controller: ($scope, $mdDialog, __env: any) => {
                    $scope.__env = __env;
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    };
                },
            });
        }
    },
};

angular
    .module("campaign")
    .component(RecommendedStepsComponent.selector, RecommendedStepsComponent);
